/* eslint-disable @typescript-eslint/naming-convention */
import { ExternalTransferDescriptionDto } from './external-transfer-description.dto';

export class ExternalTransferHeadersResponseDto {
	public Data: ExternalTransferDescriptionDto[];
	public Errors: string[];
}
